
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateEquipmenttypeDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    description: new FormControl<string | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
})
;
}
      